var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFanClub(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 22.2222C2.6674 20.8997 2.99604 19.5979 3.62302 18.4335C4.24999 17.269 5.15578 16.278 6.25938 15.5491C7.36298 14.8203 8.62999 14.3763 9.94714 14.2568C11.2643 14.1374 12.5905 14.3462 13.8072 14.8646",
    stroke: "#257FFC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6662 12.4445C13.3663 12.4445 15.5551 10.2556 15.5551 7.55557C15.5551 4.85551 13.3663 2.66669 10.6662 2.66669C7.96617 2.66669 5.77734 4.85551 5.77734 7.55557C5.77734 10.2556 7.96617 12.4445 10.6662 12.4445Z",
    stroke: "#257FFC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2218 29.3333L16.1608 23.0104C15.6286 22.4783 15.2773 21.7923 15.1567 21.0495C15.0361 20.3067 15.1523 19.5448 15.4888 18.8717C15.7429 18.3634 16.1141 17.9228 16.5719 17.5861C17.0296 17.2495 17.5609 17.0264 18.1218 16.9353C18.6826 16.8442 19.2572 16.8877 19.7979 17.0622C20.3387 17.2367 20.8303 17.5372 21.2322 17.939L22.2218 18.9286L23.2114 17.939C23.6132 17.5372 24.1047 17.2367 24.6454 17.0622C25.1861 16.8877 25.7605 16.8442 26.3213 16.9353C26.8821 17.0264 27.4133 17.2495 27.8709 17.5861C28.3286 17.9228 28.6997 18.3634 28.9537 18.8717C29.29 19.5447 29.4061 20.3065 29.2857 21.0492C29.1654 21.7919 28.8145 22.478 28.2828 23.0104L22.2218 29.3333Z",
    stroke: "#257FFC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFanClub);
export default __webpack_public_path__ + "static/media/fan-club.faf78e35.svg";
export { ForwardRef as ReactComponent };